<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <h6 class="mb-0">Contas Bancárias</h6>
      <v-btn color="primary" @click="addBankAccount" small>
        <v-icon left>mdi-plus</v-icon>
        Conta Bancária
      </v-btn>
    </div>
    <VAlert v-if="error" type="error" class="mb-0">
      {{ error }}
    </VAlert>
    <template v-else>
      <VDataTable
        v-if="bankAccounts.length > 0 || loading"
        :headers="headers"
        :items="bankAccounts"
        :loading="loading"
        :sort-by="['active']"
        :sort-desc="[true]"
      >
        <template #item.pixKeyType="{ item }">
          {{ keyTypes[item.pixKeyType] }}
        </template>
        <template #item.pixKey="{ item }">
          <v-chip
            @click="copyToClipboard(item)"
            small
            :disabled="!!successCopied"
            :color="successCopied === item.id ? 'success' : undefined"
          >
            {{ item.pixKey }}
            <v-icon v-if="successCopied === item.id" x-small right>
              mdi-check
            </v-icon>
            <v-icon v-else x-small right>mdi-content-copy</v-icon>
          </v-chip>
        </template>
        <template #item.active="{ item }">
          <v-chip :color="item.active ? 'success' : 'error'" small label>
            {{ item.active ? "Ativo" : "Inativo" }}
          </v-chip>
        </template>
        <template #item.actions="{ item }">
          <v-btn
            v-if="item.active"
            icon
            @click="inactiveBankAccount(item.id)"
            :disabled="loadingInactive === item.id"
            :loading="loadingInactive === item.id"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </VDataTable>
      <VAlert v-else type="info" class="mb-0" text>
        Nenhuma conta bancária encontrada
      </VAlert>
    </template>
    <BankAccountModal
      ref="bankAccountModal"
      @success="getBankAccounts"
      :organization="organization"
    />
  </div>
</template>

<script>
import ORGANIZATION from "@/services/admin/organizations";
import BankAccountModal from "@/components/global/BankAccountModal.vue";

export default {
  name: "OrganizationBankAccounts",
  components: {
    BankAccountModal,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bankAccounts: [],
      loading: false,
      error: null,
      successCopied: false,
      successInactive: false,
      loadingInactive: false,
      headers: [
        { text: "Banco", value: "bank" },
        { text: "Beneficiário", value: "beneficiary" },
        { text: "Tipo de Chave PIX", value: "pixKeyType" },
        { text: "Chave PIX", value: "pixKey" },
        { text: "Ativo", value: "active", align: "center" },
        { text: "Ações", value: "actions", align: "center" },
      ],
      keyTypes: {
        ID: "ID Aleatório",
        CPF: "CPF",
        CNPJ: "CNPJ",
        EMAIL: "Email",
        PHONE: "Telefone",
      },
    };
  },

  methods: {
    async getBankAccounts() {
      try {
        this.loading = true;
        this.error = null;
        const response = await ORGANIZATION.getBankAccount(
          this.organization.id
        );
        this.bankAccounts = response.bankAccounts;
      } catch (error) {
        this.error = error.message || "Erro ao buscar contas bancárias";
      } finally {
        this.loading = false;
      }
    },
    copyToClipboard(item) {
      navigator.clipboard.writeText(item.pixKey);
      this.successCopied = item.id;
      setTimeout(() => {
        this.successCopied = null;
      }, 2000);
    },
    addBankAccount() {
      this.$root.$emit("add-bank-account");
    },
    async inactiveBankAccount(bankAccountId) {
      try {
        this.loadingInactive = bankAccountId;

        await ORGANIZATION.inactiveBankAccount(
          this.organization.id,
          bankAccountId
        );
        this.getBankAccounts();

        this.successInactive = bankAccountId;
        setTimeout(() => {
          this.successInactive = null;
        }, 2000);
      } catch (error) {
        this.error = error.message || "Erro ao inativar conta bancária";
      } finally {
        this.loadingInactive = false;
      }
    },
  },
  watch: {
    organization: {
      handler() {
        this.getBankAccounts();
      },
    },
  },
  mounted() {
    this.getBankAccounts();
  },
};
</script>
